import { assertPlatform, Component, OnInit } from '@angular/core';
import { PublicService } from '../public.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss']
})
export class WalletComponent implements OnInit {
  active = 1;
  credit = "";
  key = "deactive";
  key2 = "deactive";
  key3 = "deactive";

  constructor(public publicservice: PublicService, public router: Router) {
    if (publicservice.logedIn == "false" || this.publicservice.logedIn == null) {
      this.router.navigate(['login']);
    }
    this.publicservice.getProfile().then((r) => {
      if (r.data.credit == null) {
        this.credit = "0";
      } else {
        this.credit = r.data.credit;
      }
    });
  }


  ngOnInit(): void {
  }

  backhome() {
    this.router.navigate(['home']);
  }

  shaba = new FormControl('', [
    Validators.required,
    // Validators.pattern("^[0-9]{24}"),
  ]);

  mablagh = new FormControl('', [
    Validators.required,
    // Validators.pattern("^[0-9]"),
  ]);

  mablaghCharity = new FormControl('', [
    Validators.required,
  ]);


  okClick() {
    // console.log(this.mablagh.value);

    if (this.mablagh.value > this.credit) {
      this.key = "active";
    } if (this.mablagh.value < 10000) {
      this.key3 = "active";
    }
    if (this.mablagh.value <= this.credit) {
      this.key = "deactive";
    } if (this.mablagh.value >= 10000) {
      this.key3 = "deactive";
    }
    if (this.mablagh.valid && this.shaba.valid) {
      this.publicservice.giveMoneyToUser().then((r) => {
        if( r.message == "successful") {
          alert("درخواست شما با موفقیت ثبت شد");
         }
         this.publicservice.getProfile().then((r) => {
          if (r.data.credit == null) {
            this.credit = "0";
          } else {
            this.credit = r.data.credit;
          }
        });
      });
    }
  }

  charityClick() {
    if (this.mablaghCharity.value > this.credit) {
      this.key2 = "active";
    } 
    if (this.mablaghCharity.value <= this.credit) {
      this.key2 = "deactive";
    } 
    if (this.mablaghCharity.valid) {
      this.publicservice.charityMoney().then((r) => {
        if( r.message == "successful") {
          alert("کمک شما با موفقیت ثبت شد، از کمک شما ممنونیم");
        }
        this.publicservice.getProfile().then((r) => {
          if (r.data.credit == null) {
            this.credit = "0";
          } else {
            this.credit = r.data.credit;
          }
        });
      });
    }
  }

}
